import * as yup from 'yup';

export const ReleaseSchema = yup.object().shape({
  bugs: yup.string(),
  features: yup.string(),
});
